"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE = exports.ICON = exports.COLOR = exports.BUTTON = exports.ARR_COLUMN_SPAN = void 0;
var SIZE = {
  HEADLINE_SIZE: 'titleNormal',
  SUBHEADLINE_SIZE: 'default',
  SUBHEADLINE_SIZE_MOB: 'small',
  ICON_SIZE: 'titleNormal',
  WITH_ICON_TEXT_LIMIT: 23,
  WITHOUT_ICON_TEXT_LIMIT: 28,
  CENTER_HEADLINE_TEXT_LIMIT: 50,
  SHOW_MORE_URL_SIZE: 'small'
};
exports.SIZE = SIZE;
var COLOR = {
  HEADLINE_COLOR: 'neutral',
  SUBHEADLINE_COLOR: 'neutral',
  SUBHEADLINE_COLOR_MOB: 'greyDark',
  ICON_COLOR: 'greyDark',
  SHOW_MORE_URL: 'secondaryBlue'
};
exports.COLOR = COLOR;
var ICON = 'ChevronRightIcon';
exports.ICON = ICON;
var ARR_COLUMN_SPAN = ['2', '3', '4'];
exports.ARR_COLUMN_SPAN = ARR_COLUMN_SPAN;
var BUTTON = {
  PADDING_TOP: '1rem',
  PADDING_BOTTOM: '1rem',
  PADDING_RIGHT: '2.5rem',
  PADDING_LEFT: '2.5rem',
  PADDING_RIGHT_MOBILE: '0',
  PADDING_LEFT_MOBILE: '0',
  TYPE: 'link',
  COLOR: 'neutral',
  WIDTH: '100%'
};
exports.BUTTON = BUTTON;